import { ObjectMapper } from 'json-object-mapper';
import { FormModel } from 'services/models/form-builder/form.model';
import { IModel } from 'services/models/IModel';
import { Model } from 'services/models/model';

export class EthicsChannelConfigModel extends Model implements IModel<EthicsChannelConfigModel> {
  public companyGroupId: string = '';
  public ethicsFormId: string = '';
  public securityFormId: string = '';
  public ethicsForm: FormModel = null;
  public securityForm: FormModel = null;
  public availableReportTypes: string[] = [];
  public employeeIdsWithSecurityReportAccess: string[] = [];
  public employeeIdsWithEthicsReportAccess: string[] = [];
  public authorizedToManageEthicsReports: boolean = false;
  public authorizedToManageSecurityReports: boolean = false;

  static create(input: any): EthicsChannelConfigModel {
    return ObjectMapper.deserialize<EthicsChannelConfigModel>(EthicsChannelConfigModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
